export default {
  host: process.env.VUE_APP_OSM_HOST,
  auth_callback_url: process.env.VUE_APP_OSM_HOST + process.env.VUE_APP_OSM_AUTH_CALLBACK_URI,
  map: {
    minZoom: 1,
    url: process.env.VUE_APP_OSM_TILES_URL,
    extent: [
      [
        [19.885254, 43.460894],
        [30.443115, 43.460894],
        [30.443115, 48.748945],
        [19.885254, 48.748945],
        [19.885254, 43.460894],
      ],
    ],
    tiles: {
      maxZoom: 25,
      maxNativeZoom: 17,
    },
  },
};
